export const REDUCER_NAME = 'search'




// WEBPACK FOOTER //
// ./src/modules/customer/state/search/const.js